import { createAction } from '@cobuildlab/react-simple-state';
import { fetchReportsEvent, fetchReportsEventError } from './reports-events';
import axios from 'axios';
import { BACKEND_ENDPOINT } from '../../shared/constants';

export const fetchTenantReports = createAction(
  fetchReportsEvent,
  fetchReportsEventError,
  async (data: {
    from: string;
    to: string;
    page: number;
    pageSize: number;
  }) => {
    const {  page, pageSize } = data;
    const url = `${BACKEND_ENDPOINT}/api/tenant-reports`;

    try {
      const response = await axios.get(url, {
        timeout: 60000,
        params: {
          page,
          pageSize,
        },
      });

      return response.data;
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ?? 'Error al obtener los cupones';
      throw new Error(msg);
    }
  },
);
